import Vue from "vue";
import moment from "moment";
import store from '@/store'

import ProfileQuestionnaireModal from '../components/modals/ProfileQuestionnaireModal.vue'


import axios from "axios";
import config from "../config/constants";

/**
 * https://bootstrap-vue.js.org/docs/components/modal/#modal-message-boxes
 * accepted props : https://bootstrap-vue.js.org/docs/components/modal/#comp-ref-b-modal
 * but in camelCase and not kebab-case
 */
const defaultModalOptions = {
  title: "",
  hideHeader: true,
  size: "md",
  buttonSize: "lg",
  okTitle: "OK",
  cancelTitle: "NO",
  footerClass: "p-2",
  hideHeaderClose: true,
  centered: true,
  contentClass: "pop-up-content"
};
/**
 *  language imports for translation files
 */
import * as en from '../assets/lang/_en'
import * as de from '../assets/lang/_de'
import { options } from "less";
const languages = {
  en: en,
  de: de
}
const languageNames = {
  en: 'English',
  de: 'Deutsch'
}
Vue.mixin({
  methods: {
    async logAction(action, successFunction) {
      let res = await this.api({
        path: "api/u/settings/log-action",
        action,
      });
      if (successFunction) {
        successFunction;
      }
    },
    scrollToRef(ref) {
      if (ref) {
        const el = this.$refs[ref];
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        const el = document.getElementById('LoggedIn');
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    friendlyTimeString(str) {
      return moment(str).fromNow();
    },
    getDateHours(str) {
      //return this.$date(new Date(str.replace(" ", "T")), "ddd DD MMM HH.mm");
      return moment(str.replace(" ", "T")).locale(this.$store.state.lang).format("ddd DD MMM HH:mm");
    },
    getMonth(str) {
      return moment(str.replace(" ", "T")).locale(this.$store.state.lang).format("MMM");
    },
    getDay(str) {
      return moment(str.replace(" ", "T")).locale(this.$store.state.lang).format("DD");
    },
    getDayString(str) {
      return moment(str.replace(" ", "T")).locale(this.$store.state.lang).format("ddd");
    },
    getDayStringLong(str) {
      return moment(str.replace(" ", "T")).locale(this.$store.state.lang).format("dddd");
    },
    getDate(str) {
      return moment(str).locale(this.$store.state.lang).format("ddd DD MMM Y");
    },
    getShortDate(str) {
      return moment(str).locale(this.$store.state.lang).format("DD MMM YY");
    },
    getHoursMinutes(str, isTwelveHour = false) {
      if (isTwelveHour) return moment(str.replace(" ", "T")).format("h:mm A");
      return moment(str.replace(" ", "T")).format("HH:mm");
    },
    getFormatedDate(date, format) {
      return moment(date).locale(this.$store.state.lang).format(format)
    },
    getChatDate(date) {
      return moment(date).locale(this.$store.state.lang).format('DD/MM HH:mm');
    },
    getDateLineText(appointmentStr) {
      let appointmentDate = new Date(appointmentStr).setHours(0, 0, 0, 0);
      if (navigator.userAgent.toLowerCase().indexOf("safari/")) {
        const safariDate = new Date(appointmentStr.replace(/-/g, "/"));
        appointmentDate = new Date(safariDate).setHours(0, 0, 0, 0);
      }
      const today = new Date().setHours(0, 0, 0, 0);
      const dayString = moment(appointmentDate)
        .locale(this.$store.state.lang)
        .format("dddd");
      if (appointmentDate === today) return "Today";
      if (appointmentDate === today + 86400000) return "Tomorrow";
      if (moment(appointmentDate).isoWeek() === moment().isoWeek())
        return dayString + " - This Week";
      if (moment(appointmentDate).isoWeek() === moment().isoWeek() + 1)
        return dayString + " - Next Week";
      if (moment(appointmentDate).isoWeek() === 1 && moment().isoWeek() === 52)
        return dayString + " - Next Week";
      return moment(appointmentDate).fromNow();
    },
    getFriendlyDateText(appointmentStr) {
      const x = appointmentStr.replace("T", " ");
      let appointmentDate = new Date(x).setHours(0, 0, 0, 0);
      if (navigator.userAgent.toLowerCase().indexOf("safari/")) {
        const safariDate = new Date(x.replace(/-/g, "/"));
        appointmentDate = new Date(safariDate).setHours(0, 0, 0, 0);
      }
      const today = new Date().setHours(0, 0, 0, 0);
      const dayString = moment(appointmentDate)
        .locale(this.$store.state.lang)
        .format("Do MMMM");
      if (appointmentDate === today) return "Today";
      if (appointmentDate === today + 86400000) return "Tomorrow";
      return dayString;
    },
    getTheme() {
      return "theme-" + this.$store.getters.skin
    },
    getMatchTechOptions() {
      return {
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
          "Authorization": `Bearer ` + this.$store.getters.user_id,
        }
      }
    },
    isPast(str) {
      return new Date(str.replace(" ", "T")) < new Date();
    },
    showMsgModal(msg = "something", options = defaultModalOptions) {
      const skin = this.$store.getters.skin;
      options.modalClass = "theme-" + skin;
      return this.$bvModal.msgBoxOk(msg, options);
    },
    showConfirmModal(msg = "something", options = defaultModalOptions) {
      const skin = this.$store.getters.skin;
      options.modalClass = "theme-" + skin;
      return this.$bvModal.msgBoxConfirm(msg, options);
    },
    showConversationWrapper() {
      const content = this.$createElement(ConversationWrapper)
      const skin = this.$store.getters.skin;
      options.modalClass = "conversation-modal theme-" + skin;
      options.okTitle = "Close";
      let opts = {
        title: "",
        hideHeader: true,
        size: "xl",
        buttonSize: "lg",
        okTitle: "OK",
        footerClass: "p-2",
        hideHeaderClose: true,
        centered: true,
        contentClass: "pop-up-content"
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
    async sendRequest(params) {
      params.user_id = this.$store.getters.user_id
      const path = params.path
      let payload = params
      delete payload.path
      let res = await axios.post(
        config.api_env + "/application/" + path,
        payload,
        config.options
      );
      return res.data
    },
    async api(params) {
      params.user_id = this.$store.getters.user_id
      const path = params.path
      let payload = params
      delete payload.path
      let res = await axios.post(
        config.api_env + "/application/" + path,
        payload,
        config.options
      );
      if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch((err) => { });
        return false;
      } else {
        return res.data;
      }
    },
    isLayaWellbeing() {
      return window.location.host.search('laya-wellbeing') > -1
    },
    getCurrencyPriceString(currency, amount, full = false) {
      let am = amount / 100
      let opts = {
        style: "currency",
        currency: currency.toUpperCase(),
        maximumFractionDigits: full ? 2 : 0
      }
      let value = am.toLocaleString("en-IE", opts);
      if (value.slice(-3) === '.00') {
        value = value.slice(0, value.length - 3);
      }
      return value;
    },
    _isNavigatorDefined() {
      return typeof navigator !== 'undefined' && navigator != null;
    },
    isWebView() {
      const navigator = window.navigator
      const userAgent = navigator.userAgent
      const normalizedUserAgent = userAgent.toLowerCase()
      const standalone = navigator.standalone

      const isIos =
        /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      const isAndroid = /android/.test(normalizedUserAgent)
      const isSafari = /safari/.test(normalizedUserAgent)
      const isWebview = (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari)

      return isWebview
    },
    isMobile(nav) {
      if (nav || this._isNavigatorDefined()) {
        if (!nav) {
          nav = navigator;
        }
        if (nav.product === 'ReactNative') {
          return true;
        }
        // tslint:disable-next-line:no-any
        var a = nav.userAgent || nav.vendor || window.opera;
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          .test(a) ||
          // tslint:disable-next-line:max-line-length
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
            .test(a.substr(0, 4));
      }
      return false;
    }
  },
  computed: {
    allLanguages() {
      return languageNames
    },
    getText() {
      return languages[store.state.lang].default
    }
  }
});
